// ProgramPage.tsx
import React, { useState, useEffect, useMemo } from "react";
import { Button } from "react-bootstrap";
import ProgramTable from "../components/Program/ProgramTable";
import ModalDeleteProgram from "../components/Program/DeleteProgram";
import ModalShowProgram from "../components/Program/ShowProgram";
import ProgramFormModal from "../components/Program/ProgramFormData";

import { useTranslate } from "../hooks/LanguageProvider";
import { useClipboard } from "../utilities/functions";
import { Link, useParams } from "react-router-dom";
import { usePagePreferences } from "../hooks/usePagePreferences";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

interface ProgramInterface {
  id_program: number;
  id_site?: number;
  program_date?: string;
  site?: string;
  name?: string;
  client_name?: string;
  departure?: string;
  destination?: string;
  type?: string;
  observation?: string;
  status: string;
  nom_conducteur?: string;
  prenom_conducteur?: string;
  immatriculation_vehicule?: string;
  PSN?: string;
}

const Programs: React.FC = () => {
  const { id_site, name } = useParams();
  const siteId = Number(id_site);
  const { translate } = useTranslate();
  const { copyToClipboard, copiedId } = useClipboard(
    translate("Matriculation Copied")
  );

  // -------- STATES IMPORTÃ‰S DE TON MODAL -------- //
  const [list_Program, setListProgram] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<Record<string, boolean>>({
    id_program: true,
    program_date: true,
    departure: true,
    destination: true,
    type: true,
    observation: true,
    status: true,
    nom_conducteur: true,
    immatriculation_vehicule: true,
    client_name: true,
  });

  const id_user = localStorage.getItem("userid");
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences(`programs:${id_site || "all"}`, {
    sort: "DESC",
    column: "id_site",
    limit: 10,
    currentPage: 1,
    searchValue: "",
    type: id_user === "1" ? 0 : 2,
    filterDate: "",
  });

  const [sort, setSort] = useState<"ASC" | "DESC">(listPreferences.sort === "ASC" ? "ASC" : "DESC");
  const [column, setColumn] = useState(String(listPreferences.column || "id_site"));
  const [limit, setLimit] = useState(Number(listPreferences.limit) || 10);
  const [currentPage, setCurrentPage] = useState(Number(listPreferences.currentPage) || 1);


  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [filterDate, setFilterDate] = useState<string | null>((listPreferences.filterDate as string | null) || null);


  const [type, setType] = useState(Number(listPreferences.type ?? (id_user === "1" ? 0 : 2)));
  const [searchValue, setSearchValue] = useState(String(listPreferences.searchValue || ""));


  // Fonction passÃ©e Ã  l'enfant
  const handleTypeSearch = (val: string) => {
    const numero = parseInt(val, 10);
    setType(numero);
    setCurrentPage(1);
    setListPreferences({ type: numero, currentPage: 1 });

  };

  // ------ MODALS ------ //
  const [showDeleteProgramModal, setShowDeleteProgramModal] = useState(false);
  const [showShowProgramModal, setShowShowProgramModal] = useState(false);
  const [selectedProgramId, setSelectedProgramId] = useState<number | null>( null);

  const [showFormModal, setShowFormModal] = useState(false);
  const [editProgramData, setEditProgramData] = useState<any | null>(null);

  // ------ HANDLERS ------ //
  const handleEditProgram = (program: any) => {
    setEditProgramData(program);
    setShowFormModal(true);
  };

  const handleNewProgram = () => {
    setEditProgramData(null);
    setShowFormModal(true);
  };

  const handleDeleteProgramModal = (id: number) => {
    setSelectedProgramId(id);
    setShowDeleteProgramModal(true);
  };

  const handleShowShowProgramModal = (id: number) => {
    setSelectedProgramId(id);
    setShowShowProgramModal(true);
  };

  // -------- FETCH PROGRAMS (copiÃ© Ã  lâ€™identique) -------- //
  const fetchPrograms = async (pageOverride?: number) => {
    try {
      setLoading(true);
      const pageToUse = pageOverride ?? currentPage;
      if (pageOverride) setCurrentPage(pageToUse);

      // RequÃªte principale pour rÃ©cupÃ©rer les programmes
      const res = await fetch(`${backendUrl}/api/program/search`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_user,
          limitValue: limit,
          currentPage: pageToUse,
          id_site,
          search: searchValue,// champ sur lequel filtrer
          type,
          column,
          sort,
          filters: {
            program_date: filterDate,
          },
        }),
      });

      if (!res.ok) throw new Error("Failed to fetch programs");
      const data = await res.json();

      // RequÃªte pour rÃ©cupÃ©rer le total filtrÃ© cÃ´tÃ© serveur
      const totalRes = await fetch(`${backendUrl}/api/program/totalpage`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_user,
          search: searchValue,
          type,
          id_site,
          filters: {
            program_date: filterDate,
          },
        }),
      });

      if (!totalRes.ok) throw new Error("Failed total count");
      const totalData = await totalRes.json();
      const totalCount = totalData[0]?.count || 0;

      setListProgram(Array.isArray(data) ? data : []);
      setTotal(totalCount);
      setPageCount(Math.ceil(totalCount / limit));
    } catch (e) {
      console.error(e);
      setListProgram([]);
      setTotal(0);
      setPageCount(0);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!listPreferencesLoaded) return;

    const nextLimit = Number(listPreferences.limit) || 10;
    const nextPage = Number(listPreferences.currentPage) || 1;
    const nextSearch = String(listPreferences.searchValue || "");
    const nextType = Number(listPreferences.type ?? (id_user === "1" ? 0 : 2));
    const nextColumn = String(listPreferences.column || "id_site");
    const nextSort = listPreferences.sort === "ASC" ? "ASC" : "DESC";
    const nextFilterDate = (listPreferences.filterDate as string | null) || null;

    setLimit(nextLimit);
    setCurrentPage(nextPage);
    setSearchValue(nextSearch);
    setType(nextType);
    setColumn(nextColumn);
    setSort(nextSort);
    setFilterDate(nextFilterDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listPreferencesLoaded, listPreferences, id_user]);

  useEffect(() => {
    if (!listPreferencesLoaded) return;
    fetchPrograms();
  }, [limit, currentPage, searchValue, type, column, sort, id_site, filterDate, listPreferencesLoaded]);

  const menuItems = useMemo(() => {
    return [
      ...(id_user === "1" ? ["ID Program"] : []),
      "Program Date",
      "Client",
      "Departure",
      "Destination",
      "Type",
      "Driver",
      "Vehicle",
      "Observation",
      "Status",
    ];
  }, [id_user]);

  const columnsMap = {
    ...(id_user === "1" && { id_program: "ID" }),
    program_date: "Program Date",
    client_name: "Client",
    departure: "Departure",
    destination: "Destination",
    type: "Type",
    nom_conducteur: "Driver",
    immatriculation_vehicule: "Vehicle",
    observation: "Observation",
    status: "Status",
  };




  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLimit = parseInt(e.target.value, 10);
    setLimit(newLimit);
    setCurrentPage(1);
    setListPreferences({ limit: newLimit, currentPage: 1 });
    fetchPrograms(1);
  };

  // ------------------ RENDER PAGE ------------------ //
  return (
    <div className="container-fluid py-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* ---- LEFT ---- */}
        <h4>
          {" "}
          {name} :{" "}
          <span style={{ fontSize: "19px" }}>
            ({total}) {translate("Programs")}
          </span>{" "}
        </h4>

        {/* ---- RIGHT ---- */}
        <div className="d-flex">
          <Link
            to="/Sites"
            className="btn btn-outline-secondary mt-2 mr-1"
            data-toggle="tooltip"
            data-placement="top"
            title={translate("Back to Sites")}
          >
            <i
              className="ri-arrow-left-line mr-1"
              style={{ fontSize: "1.2em" }}
            ></i>
            {translate("Back to site")}
          </Link>

          <Button variant="primary" className="mt-2" onClick={handleNewProgram}>
            <i className="ri-add-line"></i> {translate("New Program")}
          </Button>
        </div>
      </div>

      <ProgramTable
        loading={loading}
        programs={list_Program}
        id_site={siteId}
        selectedColumns={selectedColumns}
        copiedId={copiedId}
        copyToClipboard={copyToClipboard}
        translate={(t: string) => t}
        sortColumn={column}
        sortOrder={sort}
        handleSortingColumn={(col) => {
          const nextSort = sort === "ASC" ? "DESC" : "ASC";
          setColumn(col);
          setSort(nextSort);
          setCurrentPage(1);
          setListPreferences({ column: col, sort: nextSort, currentPage: 1 });
        }}
        handleShowNewDeadlineModal={() => { }}
        handleShowShowProgramModal={handleShowShowProgramModal}
        handleDeleteProgramModal={handleDeleteProgramModal}
        handleEditProgramModal={handleEditProgram}
        getStatusIcon={(status) => <span>{status}</span>}
        initialColumns={selectedColumns}
        limit={limit}
        total={total}
        pageCount={pageCount}
        currentPage={currentPage}
        handleSelectChange={handleSelectChange}
        handlePageClick={(data) => {
          const nextPage = data.selected + 1;
          setCurrentPage(nextPage);
          setListPreference("currentPage", nextPage);
          fetchPrograms(nextPage);
        }}
        columnsMap={columnsMap}
        handleColumnChange={(col) =>
          setSelectedColumns((prev) => ({ ...prev, [col]: !prev[col] }))
        }
        menuItems={menuItems}
        handleTypeSearch={handleTypeSearch}
        search={searchValue}
        handleAdvancedSearch={(e) => {
          setSearchValue(e.target.value);
          setCurrentPage(1);
          setListPreferences({ searchValue: e.target.value, currentPage: 1 });
        }}
        filterDate={filterDate}
        onFilterDateChange={(value) => {
          setFilterDate(value);
          setCurrentPage(1);
          setListPreferences({ filterDate: value || "", currentPage: 1 });
        }}
        fetchPrograms={fetchPrograms}
      />

      {/* Delete */}
      <ModalDeleteProgram
        show={showDeleteProgramModal}
        onHide={() => setShowDeleteProgramModal(false)}
        id_program={selectedProgramId}
        onSuccess={fetchPrograms}
      />

      {/* Details */}
      <ModalShowProgram
        show={showShowProgramModal}
        onHide={() => setShowShowProgramModal(false)}
        id_program={selectedProgramId}
      />

      {/* Create / Edit */}
      <ProgramFormModal
        show={showFormModal}
        onHide={() => setShowFormModal(false)}
        id_site={siteId}
        editProgramData={editProgramData}
        onSuccess={() => {
          fetchPrograms();
         // setShowFormModal(false);
        }}
      />
    </div>
  );
};

export default Programs;
